/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as BlockedRouteImport } from './routes/blocked'
import { Route as PromoRouteImport } from './routes/promo'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as LayoutPrivateRouteImport } from './routes/_layout/_private'
import { Route as LayoutAboutUsRouteImport } from './routes/_layout/about-us'
import { Route as LayoutFaqRouteImport } from './routes/_layout/faq'
import { Route as LayoutPrivacyPolicyRouteImport } from './routes/_layout/privacy-policy'
import { Route as LayoutSupportRouteImport } from './routes/_layout/support'
import { Route as LayoutTermsOfServiceRouteImport } from './routes/_layout/terms-of-service'
import { Route as AuthLoginIndexRouteImport } from './routes/_auth/login/index'
import { Route as AuthLoginOauthIndexRouteImport } from './routes/_auth/login/oauth/index'
import { Route as AuthLoginOauthLinkOldAccountRouteImport } from './routes/_auth/login/oauth/link-old-account'
import { Route as AuthLoginOauthStartRouteImport } from './routes/_auth/login/oauth/start'
import { Route as AuthLoginPasswordResetIndexRouteImport } from './routes/_auth/login/password-reset/index'
import { Route as AuthLoginPasswordResetCreateNewRouteImport } from './routes/_auth/login/password-reset/create-new'
import { Route as AuthLoginVerifyEmailIndexRouteImport } from './routes/_auth/login/verify-email/index'
import { Route as AuthLoginVerifyEmailCodeRouteImport } from './routes/_auth/login/verify-email/code'
import { Route as LayoutPrivateAppIndexRouteImport } from './routes/_layout/_private/app/index'
import { Route as LayoutPrivateAppUserRouteRouteImport } from './routes/_layout/_private/app/user/route'
import { Route as LayoutPromotionAugust2025IndexRouteImport } from './routes/_layout/promotion/august-2025/index'
import { Route as LayoutPromotionAugust2025TabsRouteImport } from './routes/_layout/promotion/august-2025/_tabs'
import { Route as LayoutPromotionFreeBankrollIndexRouteImport } from './routes/_layout/promotion/free-bankroll/index'
import { Route as LayoutPrivateAppDealsIndexRouteImport } from './routes/_layout/_private/app/deals/index'
import { Route as LayoutPrivateAppDealsRoomRouteImport } from './routes/_layout/_private/app/deals/$room'
import { Route as LayoutPrivateAppRewardsIndexRouteImport } from './routes/_layout/_private/app/rewards/index'
import { Route as LayoutPrivateAppRewardsEdgeRouteImport } from './routes/_layout/_private/app/rewards/edge'
import { Route as LayoutPrivateAppRewardsEdgeHistoryRouteImport } from './routes/_layout/_private/app/rewards/edge-history'
import { Route as LayoutPrivateAppUserAccountRouteImport } from './routes/_layout/_private/app/user/account'
import { Route as LayoutPrivateAppUserSettingsRouteImport } from './routes/_layout/_private/app/user/settings'
import { Route as LayoutPromotionAugust2025TabsAllInFlipOutsRouteImport } from './routes/_layout/promotion/august-2025/_tabs/all-in-flip-outs'
import { Route as LayoutPromotionAugust2025TabsFreeTournamentTicketsRouteImport } from './routes/_layout/promotion/august-2025/_tabs/free-tournament-tickets'
import { Route as LayoutPromotionAugust2025TabsRakeRaceRouteImport } from './routes/_layout/promotion/august-2025/_tabs/rake-race'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const BlockedRoute = BlockedRouteImport.update({
  id: '/blocked',
  path: '/blocked',
  getParentRoute: () => rootRouteImport,
} as any)
const PromoRoute = PromoRouteImport.update({
  id: '/promo',
  path: '/promo',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutPrivateRoute = LayoutPrivateRouteImport.update({
  id: '/_private',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutAboutUsRoute = LayoutAboutUsRouteImport.update({
  id: '/about-us',
  path: '/about-us',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutFaqRoute = LayoutFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutPrivacyPolicyRoute = LayoutPrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSupportRoute = LayoutSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTermsOfServiceRoute = LayoutTermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => LayoutRoute,
} as any)
const AuthLoginIndexRoute = AuthLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginOauthIndexRoute = AuthLoginOauthIndexRouteImport.update({
  id: '/login/oauth/',
  path: '/login/oauth/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginOauthLinkOldAccountRoute =
  AuthLoginOauthLinkOldAccountRouteImport.update({
    id: '/login/oauth/link-old-account',
    path: '/login/oauth/link-old-account',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthLoginOauthStartRoute = AuthLoginOauthStartRouteImport.update({
  id: '/login/oauth/start',
  path: '/login/oauth/start',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginPasswordResetIndexRoute =
  AuthLoginPasswordResetIndexRouteImport.update({
    id: '/login/password-reset/',
    path: '/login/password-reset/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthLoginPasswordResetCreateNewRoute =
  AuthLoginPasswordResetCreateNewRouteImport.update({
    id: '/login/password-reset/create-new',
    path: '/login/password-reset/create-new',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthLoginVerifyEmailIndexRoute =
  AuthLoginVerifyEmailIndexRouteImport.update({
    id: '/login/verify-email/',
    path: '/login/verify-email/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthLoginVerifyEmailCodeRoute =
  AuthLoginVerifyEmailCodeRouteImport.update({
    id: '/login/verify-email/code',
    path: '/login/verify-email/code',
    getParentRoute: () => AuthRoute,
  } as any)
const LayoutPrivateAppIndexRoute = LayoutPrivateAppIndexRouteImport.update({
  id: '/app/',
  path: '/app/',
  getParentRoute: () => LayoutPrivateRoute,
} as any)
const LayoutPrivateAppUserRouteRoute =
  LayoutPrivateAppUserRouteRouteImport.update({
    id: '/app/user',
    path: '/app/user',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)
const LayoutPromotionAugust2025IndexRoute =
  LayoutPromotionAugust2025IndexRouteImport.update({
    id: '/promotion/august-2025/',
    path: '/promotion/august-2025/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutPromotionAugust2025TabsRoute =
  LayoutPromotionAugust2025TabsRouteImport.update({
    id: '/promotion/august-2025/_tabs',
    path: '/promotion/august-2025',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutPromotionFreeBankrollIndexRoute =
  LayoutPromotionFreeBankrollIndexRouteImport.update({
    id: '/promotion/free-bankroll/',
    path: '/promotion/free-bankroll/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutPrivateAppDealsIndexRoute =
  LayoutPrivateAppDealsIndexRouteImport.update({
    id: '/app/deals/',
    path: '/app/deals/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)
const LayoutPrivateAppDealsRoomRoute =
  LayoutPrivateAppDealsRoomRouteImport.update({
    id: '/app/deals/$room',
    path: '/app/deals/$room',
    getParentRoute: () => LayoutPrivateRoute,
  } as any).lazy(() =>
    import('./routes/_layout/_private/app/deals/$room.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutPrivateAppRewardsIndexRoute =
  LayoutPrivateAppRewardsIndexRouteImport.update({
    id: '/app/rewards/',
    path: '/app/rewards/',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)
const LayoutPrivateAppRewardsEdgeRoute =
  LayoutPrivateAppRewardsEdgeRouteImport.update({
    id: '/app/rewards/edge',
    path: '/app/rewards/edge',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)
const LayoutPrivateAppRewardsEdgeHistoryRoute =
  LayoutPrivateAppRewardsEdgeHistoryRouteImport.update({
    id: '/app/rewards/edge-history',
    path: '/app/rewards/edge-history',
    getParentRoute: () => LayoutPrivateRoute,
  } as any)
const LayoutPrivateAppUserAccountRoute =
  LayoutPrivateAppUserAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => LayoutPrivateAppUserRouteRoute,
  } as any)
const LayoutPrivateAppUserSettingsRoute =
  LayoutPrivateAppUserSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => LayoutPrivateAppUserRouteRoute,
  } as any)
const LayoutPromotionAugust2025TabsAllInFlipOutsRoute =
  LayoutPromotionAugust2025TabsAllInFlipOutsRouteImport.update({
    id: '/all-in-flip-outs',
    path: '/all-in-flip-outs',
    getParentRoute: () => LayoutPromotionAugust2025TabsRoute,
  } as any)
const LayoutPromotionAugust2025TabsFreeTournamentTicketsRoute =
  LayoutPromotionAugust2025TabsFreeTournamentTicketsRouteImport.update({
    id: '/free-tournament-tickets',
    path: '/free-tournament-tickets',
    getParentRoute: () => LayoutPromotionAugust2025TabsRoute,
  } as any)
const LayoutPromotionAugust2025TabsRakeRaceRoute =
  LayoutPromotionAugust2025TabsRakeRaceRouteImport.update({
    id: '/rake-race',
    path: '/rake-race',
    getParentRoute: () => LayoutPromotionAugust2025TabsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof LayoutIndexRoute
  '/blocked': typeof BlockedRoute
  '/promo': typeof PromoRoute
  '/signup': typeof AuthSignupRoute
  '/about-us': typeof LayoutAboutUsRoute
  '/faq': typeof LayoutFaqRoute
  '/privacy-policy': typeof LayoutPrivacyPolicyRoute
  '/support': typeof LayoutSupportRoute
  '/terms-of-service': typeof LayoutTermsOfServiceRoute
  '/login/': typeof AuthLoginIndexRoute
  '/app/user': typeof LayoutPrivateAppUserRouteRouteWithChildren
  '/login/oauth/link-old-account': typeof AuthLoginOauthLinkOldAccountRoute
  '/login/oauth/start': typeof AuthLoginOauthStartRoute
  '/login/password-reset/create-new': typeof AuthLoginPasswordResetCreateNewRoute
  '/login/verify-email/code': typeof AuthLoginVerifyEmailCodeRoute
  '/promotion/august-2025': typeof LayoutPromotionAugust2025TabsRouteWithChildren
  '/login/oauth/': typeof AuthLoginOauthIndexRoute
  '/login/password-reset/': typeof AuthLoginPasswordResetIndexRoute
  '/login/verify-email/': typeof AuthLoginVerifyEmailIndexRoute
  '/app/': typeof LayoutPrivateAppIndexRoute
  '/promotion/august-2025/': typeof LayoutPromotionAugust2025IndexRoute
  '/promotion/free-bankroll/': typeof LayoutPromotionFreeBankrollIndexRoute
  '/app/deals/$room': typeof LayoutPrivateAppDealsRoomRoute
  '/app/rewards/edge': typeof LayoutPrivateAppRewardsEdgeRoute
  '/app/rewards/edge-history': typeof LayoutPrivateAppRewardsEdgeHistoryRoute
  '/app/user/account': typeof LayoutPrivateAppUserAccountRoute
  '/app/user/settings': typeof LayoutPrivateAppUserSettingsRoute
  '/promotion/august-2025/all-in-flip-outs': typeof LayoutPromotionAugust2025TabsAllInFlipOutsRoute
  '/promotion/august-2025/free-tournament-tickets': typeof LayoutPromotionAugust2025TabsFreeTournamentTicketsRoute
  '/promotion/august-2025/rake-race': typeof LayoutPromotionAugust2025TabsRakeRaceRoute
  '/app/deals/': typeof LayoutPrivateAppDealsIndexRoute
  '/app/rewards/': typeof LayoutPrivateAppRewardsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof LayoutIndexRoute
  '/blocked': typeof BlockedRoute
  '/promo': typeof PromoRoute
  '/signup': typeof AuthSignupRoute
  '/about-us': typeof LayoutAboutUsRoute
  '/faq': typeof LayoutFaqRoute
  '/privacy-policy': typeof LayoutPrivacyPolicyRoute
  '/support': typeof LayoutSupportRoute
  '/terms-of-service': typeof LayoutTermsOfServiceRoute
  '/login': typeof AuthLoginIndexRoute
  '/app/user': typeof LayoutPrivateAppUserRouteRouteWithChildren
  '/login/oauth/link-old-account': typeof AuthLoginOauthLinkOldAccountRoute
  '/login/oauth/start': typeof AuthLoginOauthStartRoute
  '/login/password-reset/create-new': typeof AuthLoginPasswordResetCreateNewRoute
  '/login/verify-email/code': typeof AuthLoginVerifyEmailCodeRoute
  '/promotion/august-2025': typeof LayoutPromotionAugust2025IndexRoute
  '/login/oauth': typeof AuthLoginOauthIndexRoute
  '/login/password-reset': typeof AuthLoginPasswordResetIndexRoute
  '/login/verify-email': typeof AuthLoginVerifyEmailIndexRoute
  '/app': typeof LayoutPrivateAppIndexRoute
  '/promotion/free-bankroll': typeof LayoutPromotionFreeBankrollIndexRoute
  '/app/deals/$room': typeof LayoutPrivateAppDealsRoomRoute
  '/app/rewards/edge': typeof LayoutPrivateAppRewardsEdgeRoute
  '/app/rewards/edge-history': typeof LayoutPrivateAppRewardsEdgeHistoryRoute
  '/app/user/account': typeof LayoutPrivateAppUserAccountRoute
  '/app/user/settings': typeof LayoutPrivateAppUserSettingsRoute
  '/promotion/august-2025/all-in-flip-outs': typeof LayoutPromotionAugust2025TabsAllInFlipOutsRoute
  '/promotion/august-2025/free-tournament-tickets': typeof LayoutPromotionAugust2025TabsFreeTournamentTicketsRoute
  '/promotion/august-2025/rake-race': typeof LayoutPromotionAugust2025TabsRakeRaceRoute
  '/app/deals': typeof LayoutPrivateAppDealsIndexRoute
  '/app/rewards': typeof LayoutPrivateAppRewardsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_layout': typeof LayoutRouteWithChildren
  '/blocked': typeof BlockedRoute
  '/promo': typeof PromoRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/_layout/_private': typeof LayoutPrivateRouteWithChildren
  '/_layout/about-us': typeof LayoutAboutUsRoute
  '/_layout/faq': typeof LayoutFaqRoute
  '/_layout/privacy-policy': typeof LayoutPrivacyPolicyRoute
  '/_layout/support': typeof LayoutSupportRoute
  '/_layout/terms-of-service': typeof LayoutTermsOfServiceRoute
  '/_layout/': typeof LayoutIndexRoute
  '/_auth/login/': typeof AuthLoginIndexRoute
  '/_layout/_private/app/user': typeof LayoutPrivateAppUserRouteRouteWithChildren
  '/_auth/login/oauth/link-old-account': typeof AuthLoginOauthLinkOldAccountRoute
  '/_auth/login/oauth/start': typeof AuthLoginOauthStartRoute
  '/_auth/login/password-reset/create-new': typeof AuthLoginPasswordResetCreateNewRoute
  '/_auth/login/verify-email/code': typeof AuthLoginVerifyEmailCodeRoute
  '/_layout/promotion/august-2025/_tabs': typeof LayoutPromotionAugust2025TabsRouteWithChildren
  '/_auth/login/oauth/': typeof AuthLoginOauthIndexRoute
  '/_auth/login/password-reset/': typeof AuthLoginPasswordResetIndexRoute
  '/_auth/login/verify-email/': typeof AuthLoginVerifyEmailIndexRoute
  '/_layout/_private/app/': typeof LayoutPrivateAppIndexRoute
  '/_layout/promotion/august-2025/': typeof LayoutPromotionAugust2025IndexRoute
  '/_layout/promotion/free-bankroll/': typeof LayoutPromotionFreeBankrollIndexRoute
  '/_layout/_private/app/deals/$room': typeof LayoutPrivateAppDealsRoomRoute
  '/_layout/_private/app/rewards/edge': typeof LayoutPrivateAppRewardsEdgeRoute
  '/_layout/_private/app/rewards/edge-history': typeof LayoutPrivateAppRewardsEdgeHistoryRoute
  '/_layout/_private/app/user/account': typeof LayoutPrivateAppUserAccountRoute
  '/_layout/_private/app/user/settings': typeof LayoutPrivateAppUserSettingsRoute
  '/_layout/promotion/august-2025/_tabs/all-in-flip-outs': typeof LayoutPromotionAugust2025TabsAllInFlipOutsRoute
  '/_layout/promotion/august-2025/_tabs/free-tournament-tickets': typeof LayoutPromotionAugust2025TabsFreeTournamentTicketsRoute
  '/_layout/promotion/august-2025/_tabs/rake-race': typeof LayoutPromotionAugust2025TabsRakeRaceRoute
  '/_layout/_private/app/deals/': typeof LayoutPrivateAppDealsIndexRoute
  '/_layout/_private/app/rewards/': typeof LayoutPrivateAppRewardsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/blocked'
    | '/promo'
    | '/signup'
    | '/about-us'
    | '/faq'
    | '/privacy-policy'
    | '/support'
    | '/terms-of-service'
    | '/login/'
    | '/app/user'
    | '/login/oauth/link-old-account'
    | '/login/oauth/start'
    | '/login/password-reset/create-new'
    | '/login/verify-email/code'
    | '/promotion/august-2025'
    | '/login/oauth/'
    | '/login/password-reset/'
    | '/login/verify-email/'
    | '/app/'
    | '/promotion/august-2025/'
    | '/promotion/free-bankroll/'
    | '/app/deals/$room'
    | '/app/rewards/edge'
    | '/app/rewards/edge-history'
    | '/app/user/account'
    | '/app/user/settings'
    | '/promotion/august-2025/all-in-flip-outs'
    | '/promotion/august-2025/free-tournament-tickets'
    | '/promotion/august-2025/rake-race'
    | '/app/deals/'
    | '/app/rewards/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/blocked'
    | '/promo'
    | '/signup'
    | '/about-us'
    | '/faq'
    | '/privacy-policy'
    | '/support'
    | '/terms-of-service'
    | '/login'
    | '/app/user'
    | '/login/oauth/link-old-account'
    | '/login/oauth/start'
    | '/login/password-reset/create-new'
    | '/login/verify-email/code'
    | '/promotion/august-2025'
    | '/login/oauth'
    | '/login/password-reset'
    | '/login/verify-email'
    | '/app'
    | '/promotion/free-bankroll'
    | '/app/deals/$room'
    | '/app/rewards/edge'
    | '/app/rewards/edge-history'
    | '/app/user/account'
    | '/app/user/settings'
    | '/promotion/august-2025/all-in-flip-outs'
    | '/promotion/august-2025/free-tournament-tickets'
    | '/promotion/august-2025/rake-race'
    | '/app/deals'
    | '/app/rewards'
  id:
    | '__root__'
    | '/_auth'
    | '/_layout'
    | '/blocked'
    | '/promo'
    | '/_auth/signup'
    | '/_layout/_private'
    | '/_layout/about-us'
    | '/_layout/faq'
    | '/_layout/privacy-policy'
    | '/_layout/support'
    | '/_layout/terms-of-service'
    | '/_layout/'
    | '/_auth/login/'
    | '/_layout/_private/app/user'
    | '/_auth/login/oauth/link-old-account'
    | '/_auth/login/oauth/start'
    | '/_auth/login/password-reset/create-new'
    | '/_auth/login/verify-email/code'
    | '/_layout/promotion/august-2025/_tabs'
    | '/_auth/login/oauth/'
    | '/_auth/login/password-reset/'
    | '/_auth/login/verify-email/'
    | '/_layout/_private/app/'
    | '/_layout/promotion/august-2025/'
    | '/_layout/promotion/free-bankroll/'
    | '/_layout/_private/app/deals/$room'
    | '/_layout/_private/app/rewards/edge'
    | '/_layout/_private/app/rewards/edge-history'
    | '/_layout/_private/app/user/account'
    | '/_layout/_private/app/user/settings'
    | '/_layout/promotion/august-2025/_tabs/all-in-flip-outs'
    | '/_layout/promotion/august-2025/_tabs/free-tournament-tickets'
    | '/_layout/promotion/august-2025/_tabs/rake-race'
    | '/_layout/_private/app/deals/'
    | '/_layout/_private/app/rewards/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LayoutRoute: typeof LayoutRouteWithChildren
  BlockedRoute: typeof BlockedRoute
  PromoRoute: typeof PromoRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blocked': {
      id: '/blocked'
      path: '/blocked'
      fullPath: '/blocked'
      preLoaderRoute: typeof BlockedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/promo': {
      id: '/promo'
      path: '/promo'
      fullPath: '/promo'
      preLoaderRoute: typeof PromoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/_private': {
      id: '/_layout/_private'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof LayoutPrivateRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/about-us': {
      id: '/_layout/about-us'
      path: '/about-us'
      fullPath: '/about-us'
      preLoaderRoute: typeof LayoutAboutUsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/faq': {
      id: '/_layout/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof LayoutFaqRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/privacy-policy': {
      id: '/_layout/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof LayoutPrivacyPolicyRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/support': {
      id: '/_layout/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof LayoutSupportRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/terms-of-service': {
      id: '/_layout/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof LayoutTermsOfServiceRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_auth/login/': {
      id: '/_auth/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof AuthLoginIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login/oauth/': {
      id: '/_auth/login/oauth/'
      path: '/login/oauth'
      fullPath: '/login/oauth/'
      preLoaderRoute: typeof AuthLoginOauthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login/oauth/link-old-account': {
      id: '/_auth/login/oauth/link-old-account'
      path: '/login/oauth/link-old-account'
      fullPath: '/login/oauth/link-old-account'
      preLoaderRoute: typeof AuthLoginOauthLinkOldAccountRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login/oauth/start': {
      id: '/_auth/login/oauth/start'
      path: '/login/oauth/start'
      fullPath: '/login/oauth/start'
      preLoaderRoute: typeof AuthLoginOauthStartRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login/password-reset/': {
      id: '/_auth/login/password-reset/'
      path: '/login/password-reset'
      fullPath: '/login/password-reset/'
      preLoaderRoute: typeof AuthLoginPasswordResetIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login/password-reset/create-new': {
      id: '/_auth/login/password-reset/create-new'
      path: '/login/password-reset/create-new'
      fullPath: '/login/password-reset/create-new'
      preLoaderRoute: typeof AuthLoginPasswordResetCreateNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login/verify-email/': {
      id: '/_auth/login/verify-email/'
      path: '/login/verify-email'
      fullPath: '/login/verify-email/'
      preLoaderRoute: typeof AuthLoginVerifyEmailIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login/verify-email/code': {
      id: '/_auth/login/verify-email/code'
      path: '/login/verify-email/code'
      fullPath: '/login/verify-email/code'
      preLoaderRoute: typeof AuthLoginVerifyEmailCodeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_layout/_private/app/': {
      id: '/_layout/_private/app/'
      path: '/app'
      fullPath: '/app/'
      preLoaderRoute: typeof LayoutPrivateAppIndexRouteImport
      parentRoute: typeof LayoutPrivateRoute
    }
    '/_layout/_private/app/user': {
      id: '/_layout/_private/app/user'
      path: '/app/user'
      fullPath: '/app/user'
      preLoaderRoute: typeof LayoutPrivateAppUserRouteRouteImport
      parentRoute: typeof LayoutPrivateRoute
    }
    '/_layout/promotion/august-2025/': {
      id: '/_layout/promotion/august-2025/'
      path: '/promotion/august-2025'
      fullPath: '/promotion/august-2025/'
      preLoaderRoute: typeof LayoutPromotionAugust2025IndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/promotion/august-2025/_tabs': {
      id: '/_layout/promotion/august-2025/_tabs'
      path: '/promotion/august-2025'
      fullPath: '/promotion/august-2025'
      preLoaderRoute: typeof LayoutPromotionAugust2025TabsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/promotion/free-bankroll/': {
      id: '/_layout/promotion/free-bankroll/'
      path: '/promotion/free-bankroll'
      fullPath: '/promotion/free-bankroll/'
      preLoaderRoute: typeof LayoutPromotionFreeBankrollIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/_private/app/deals/': {
      id: '/_layout/_private/app/deals/'
      path: '/app/deals'
      fullPath: '/app/deals/'
      preLoaderRoute: typeof LayoutPrivateAppDealsIndexRouteImport
      parentRoute: typeof LayoutPrivateRoute
    }
    '/_layout/_private/app/deals/$room': {
      id: '/_layout/_private/app/deals/$room'
      path: '/app/deals/$room'
      fullPath: '/app/deals/$room'
      preLoaderRoute: typeof LayoutPrivateAppDealsRoomRouteImport
      parentRoute: typeof LayoutPrivateRoute
    }
    '/_layout/_private/app/rewards/': {
      id: '/_layout/_private/app/rewards/'
      path: '/app/rewards'
      fullPath: '/app/rewards/'
      preLoaderRoute: typeof LayoutPrivateAppRewardsIndexRouteImport
      parentRoute: typeof LayoutPrivateRoute
    }
    '/_layout/_private/app/rewards/edge': {
      id: '/_layout/_private/app/rewards/edge'
      path: '/app/rewards/edge'
      fullPath: '/app/rewards/edge'
      preLoaderRoute: typeof LayoutPrivateAppRewardsEdgeRouteImport
      parentRoute: typeof LayoutPrivateRoute
    }
    '/_layout/_private/app/rewards/edge-history': {
      id: '/_layout/_private/app/rewards/edge-history'
      path: '/app/rewards/edge-history'
      fullPath: '/app/rewards/edge-history'
      preLoaderRoute: typeof LayoutPrivateAppRewardsEdgeHistoryRouteImport
      parentRoute: typeof LayoutPrivateRoute
    }
    '/_layout/_private/app/user/account': {
      id: '/_layout/_private/app/user/account'
      path: '/account'
      fullPath: '/app/user/account'
      preLoaderRoute: typeof LayoutPrivateAppUserAccountRouteImport
      parentRoute: typeof LayoutPrivateAppUserRouteRoute
    }
    '/_layout/_private/app/user/settings': {
      id: '/_layout/_private/app/user/settings'
      path: '/settings'
      fullPath: '/app/user/settings'
      preLoaderRoute: typeof LayoutPrivateAppUserSettingsRouteImport
      parentRoute: typeof LayoutPrivateAppUserRouteRoute
    }
    '/_layout/promotion/august-2025/_tabs/all-in-flip-outs': {
      id: '/_layout/promotion/august-2025/_tabs/all-in-flip-outs'
      path: '/all-in-flip-outs'
      fullPath: '/promotion/august-2025/all-in-flip-outs'
      preLoaderRoute: typeof LayoutPromotionAugust2025TabsAllInFlipOutsRouteImport
      parentRoute: typeof LayoutPromotionAugust2025TabsRoute
    }
    '/_layout/promotion/august-2025/_tabs/free-tournament-tickets': {
      id: '/_layout/promotion/august-2025/_tabs/free-tournament-tickets'
      path: '/free-tournament-tickets'
      fullPath: '/promotion/august-2025/free-tournament-tickets'
      preLoaderRoute: typeof LayoutPromotionAugust2025TabsFreeTournamentTicketsRouteImport
      parentRoute: typeof LayoutPromotionAugust2025TabsRoute
    }
    '/_layout/promotion/august-2025/_tabs/rake-race': {
      id: '/_layout/promotion/august-2025/_tabs/rake-race'
      path: '/rake-race'
      fullPath: '/promotion/august-2025/rake-race'
      preLoaderRoute: typeof LayoutPromotionAugust2025TabsRakeRaceRouteImport
      parentRoute: typeof LayoutPromotionAugust2025TabsRoute
    }
  }
}

interface AuthRouteChildren {
  AuthSignupRoute: typeof AuthSignupRoute
  AuthLoginIndexRoute: typeof AuthLoginIndexRoute
  AuthLoginOauthLinkOldAccountRoute: typeof AuthLoginOauthLinkOldAccountRoute
  AuthLoginOauthStartRoute: typeof AuthLoginOauthStartRoute
  AuthLoginPasswordResetCreateNewRoute: typeof AuthLoginPasswordResetCreateNewRoute
  AuthLoginVerifyEmailCodeRoute: typeof AuthLoginVerifyEmailCodeRoute
  AuthLoginOauthIndexRoute: typeof AuthLoginOauthIndexRoute
  AuthLoginPasswordResetIndexRoute: typeof AuthLoginPasswordResetIndexRoute
  AuthLoginVerifyEmailIndexRoute: typeof AuthLoginVerifyEmailIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthSignupRoute: AuthSignupRoute,
  AuthLoginIndexRoute: AuthLoginIndexRoute,
  AuthLoginOauthLinkOldAccountRoute: AuthLoginOauthLinkOldAccountRoute,
  AuthLoginOauthStartRoute: AuthLoginOauthStartRoute,
  AuthLoginPasswordResetCreateNewRoute: AuthLoginPasswordResetCreateNewRoute,
  AuthLoginVerifyEmailCodeRoute: AuthLoginVerifyEmailCodeRoute,
  AuthLoginOauthIndexRoute: AuthLoginOauthIndexRoute,
  AuthLoginPasswordResetIndexRoute: AuthLoginPasswordResetIndexRoute,
  AuthLoginVerifyEmailIndexRoute: AuthLoginVerifyEmailIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface LayoutPrivateAppUserRouteRouteChildren {
  LayoutPrivateAppUserAccountRoute: typeof LayoutPrivateAppUserAccountRoute
  LayoutPrivateAppUserSettingsRoute: typeof LayoutPrivateAppUserSettingsRoute
}

const LayoutPrivateAppUserRouteRouteChildren: LayoutPrivateAppUserRouteRouteChildren =
  {
    LayoutPrivateAppUserAccountRoute: LayoutPrivateAppUserAccountRoute,
    LayoutPrivateAppUserSettingsRoute: LayoutPrivateAppUserSettingsRoute,
  }

const LayoutPrivateAppUserRouteRouteWithChildren =
  LayoutPrivateAppUserRouteRoute._addFileChildren(
    LayoutPrivateAppUserRouteRouteChildren,
  )

interface LayoutPrivateRouteChildren {
  LayoutPrivateAppUserRouteRoute: typeof LayoutPrivateAppUserRouteRouteWithChildren
  LayoutPrivateAppIndexRoute: typeof LayoutPrivateAppIndexRoute
  LayoutPrivateAppDealsRoomRoute: typeof LayoutPrivateAppDealsRoomRoute
  LayoutPrivateAppRewardsEdgeRoute: typeof LayoutPrivateAppRewardsEdgeRoute
  LayoutPrivateAppRewardsEdgeHistoryRoute: typeof LayoutPrivateAppRewardsEdgeHistoryRoute
  LayoutPrivateAppDealsIndexRoute: typeof LayoutPrivateAppDealsIndexRoute
  LayoutPrivateAppRewardsIndexRoute: typeof LayoutPrivateAppRewardsIndexRoute
}

const LayoutPrivateRouteChildren: LayoutPrivateRouteChildren = {
  LayoutPrivateAppUserRouteRoute: LayoutPrivateAppUserRouteRouteWithChildren,
  LayoutPrivateAppIndexRoute: LayoutPrivateAppIndexRoute,
  LayoutPrivateAppDealsRoomRoute: LayoutPrivateAppDealsRoomRoute,
  LayoutPrivateAppRewardsEdgeRoute: LayoutPrivateAppRewardsEdgeRoute,
  LayoutPrivateAppRewardsEdgeHistoryRoute:
    LayoutPrivateAppRewardsEdgeHistoryRoute,
  LayoutPrivateAppDealsIndexRoute: LayoutPrivateAppDealsIndexRoute,
  LayoutPrivateAppRewardsIndexRoute: LayoutPrivateAppRewardsIndexRoute,
}

const LayoutPrivateRouteWithChildren = LayoutPrivateRoute._addFileChildren(
  LayoutPrivateRouteChildren,
)

interface LayoutPromotionAugust2025TabsRouteChildren {
  LayoutPromotionAugust2025TabsAllInFlipOutsRoute: typeof LayoutPromotionAugust2025TabsAllInFlipOutsRoute
  LayoutPromotionAugust2025TabsFreeTournamentTicketsRoute: typeof LayoutPromotionAugust2025TabsFreeTournamentTicketsRoute
  LayoutPromotionAugust2025TabsRakeRaceRoute: typeof LayoutPromotionAugust2025TabsRakeRaceRoute
}

const LayoutPromotionAugust2025TabsRouteChildren: LayoutPromotionAugust2025TabsRouteChildren =
  {
    LayoutPromotionAugust2025TabsAllInFlipOutsRoute:
      LayoutPromotionAugust2025TabsAllInFlipOutsRoute,
    LayoutPromotionAugust2025TabsFreeTournamentTicketsRoute:
      LayoutPromotionAugust2025TabsFreeTournamentTicketsRoute,
    LayoutPromotionAugust2025TabsRakeRaceRoute:
      LayoutPromotionAugust2025TabsRakeRaceRoute,
  }

const LayoutPromotionAugust2025TabsRouteWithChildren =
  LayoutPromotionAugust2025TabsRoute._addFileChildren(
    LayoutPromotionAugust2025TabsRouteChildren,
  )

interface LayoutRouteChildren {
  LayoutPrivateRoute: typeof LayoutPrivateRouteWithChildren
  LayoutAboutUsRoute: typeof LayoutAboutUsRoute
  LayoutFaqRoute: typeof LayoutFaqRoute
  LayoutPrivacyPolicyRoute: typeof LayoutPrivacyPolicyRoute
  LayoutSupportRoute: typeof LayoutSupportRoute
  LayoutTermsOfServiceRoute: typeof LayoutTermsOfServiceRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutPromotionAugust2025TabsRoute: typeof LayoutPromotionAugust2025TabsRouteWithChildren
  LayoutPromotionAugust2025IndexRoute: typeof LayoutPromotionAugust2025IndexRoute
  LayoutPromotionFreeBankrollIndexRoute: typeof LayoutPromotionFreeBankrollIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutPrivateRoute: LayoutPrivateRouteWithChildren,
  LayoutAboutUsRoute: LayoutAboutUsRoute,
  LayoutFaqRoute: LayoutFaqRoute,
  LayoutPrivacyPolicyRoute: LayoutPrivacyPolicyRoute,
  LayoutSupportRoute: LayoutSupportRoute,
  LayoutTermsOfServiceRoute: LayoutTermsOfServiceRoute,
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutPromotionAugust2025TabsRoute:
    LayoutPromotionAugust2025TabsRouteWithChildren,
  LayoutPromotionAugust2025IndexRoute: LayoutPromotionAugust2025IndexRoute,
  LayoutPromotionFreeBankrollIndexRoute: LayoutPromotionFreeBankrollIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LayoutRoute: LayoutRouteWithChildren,
  BlockedRoute: BlockedRoute,
  PromoRoute: PromoRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
